export default "__VITE_ASSET__bf7e6319__"